export default "__VITE_ASSET__DJY2aIV1__"